// page 1 block id
export const GET_STARTED = 'getStarted';
export const EDUCATORS_SEC = 'educatorsSection';
export const BATCHES_SEC = 'batchesSection';
export const ABOUT_EXAM_SEC = 'aboutExamSection';
export const STORE = 'store';

// page name
export const GOAL_HOME = 'Goal home';
export const SUBSCRIPTION = 'Goal subscription';
export const SUCCESS_STORY = 'success story';
export const STORE_MAP = 'store';
//
export const EDUCATORS = 'educators';
export const BATCH = 'batch';
export const SUBSCRIPTION_PLANS = 'subscription plans';
export const SUCCESS_STORIES = 'success stories';
export const ABOUT_EXAM = 'about exam';

export const TABSID = {
  GET_STARTED: 'tab_get_started',
  EDUCATORS_SEC: 'tab_educators',
  BATCHES_SEC: 'tab_batch',
  SUBSCRIPTION_PLANS: 'tab_subscription_plans',
  SUCCESS_STORIES: 'tab_success_stories',
  ABOUT_EXAM: 'tab_about_exam',
  STORE: 'tab_store'
};

export const ABOUT_TAB = {
  id: 'tab_about_exam', // unique id starting from _tab
  label: 'About exam', // label to show on header
  sectionName: 'about exam', // section name for event
  sectionId: ABOUT_EXAM_SEC, // section document id
  hash: 'about-exam', // hash for section
  page: '' // for new page tab
};

export const STORE_TAB = {
  id: 'tab_store',
  label: 'Store',
  sectionName: 'store',
  sectionId: '',
  hash: '',
  page: 'store'
};

export const HEADER_TABS = [
  {
    id: 'tab_get_started',
    label: 'Get started',
    sectionName: 'getStarted',
    sectionId: GET_STARTED,
    hash: '',
    page: 'Goal home'
  },
  {
    id: 'tab_educators',
    label: 'Educators',
    sectionId: EDUCATORS_SEC,
    sectionName: 'educators',
    hash: 'educators',
    page: ''
  },
  {
    id: 'tab_batch',
    label: 'Batch',
    sectionId: BATCHES_SEC,
    sectionName: 'batch',
    hash: 'batches',
    page: ''
  },
  {
    id: 'tab_subscription_plans',
    label: 'Subscription plan',
    sectionId: '',
    sectionName: 'subscription plans',
    hash: '',
    page: 'Goal subscription'
  },
  {
    id: 'tab_success_stories',
    label: 'Success stories',
    sectionId: '',
    sectionName: 'success stories',
    hash: '',
    page: 'success story'
  }
];
// Install banner deafult props
export const educatorDefaultProps = {
  title: 'All in one place',
  description:
    'Schedule your classes, engage with learners, see your performance across your courses',
  androidApp:
    'https://play.google.com/store/apps/details?id=com.unacademy&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26',
  iosApp:
    'https://apps.apple.com/in/app/unacademy-educator-app/id1156375099%26referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526'
};

export const learnerDefaultProps = {
  title: 'Online preparation like never before',
  description: [
    'Interactive live classes',
    'Mock tests and practice questions',
    'High-quality notes',
    'Doubt solving'
  ],
  androidApp:
    'https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26',
  iosApp:
    'https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526'
};

// exp name
export const NEW_GOAL_PAGE_EXP = 'web_landing_page_redesign';

// Default Store Tab Experiment key
export const DEFAULT_STORE_TAB = 'default_store_tab';

// offline center icons file maping
export const OFFLINE_CENTER_ICONS = {
  indore: '/offlineCentres/indore_V1.svg',
  kota: '/offlineCentres/kota.svg',
  lucknow: '/offlineCentres/lucknow.svg',
  noida: '/offlineCentres/noida.svg',
  patna: '/offlineCentres/patna.svg',
  ahmedabad: '/offlineCentres/ahmedabad.svg',
  bangalore: '/offlineCentres/bangalore.svg',
  delhi: '/offlineCentres/delhi.svg',
  chandigarh: '/offlineCentres/chandigarh.svg',
  jaipur: '/offlineCentres/jaipur.svg',
  pune: '/offlineCentres/pune.svg',
  vijayawada: '/offlineCentres/vijayawada.svg',
  morecities: '/offlineCentres/morecities.svg',
  viewAll: '/offlineCentres/viewAll.svg'
};

// offline cenetr CTA url
export const OFFLINE_CENTER_CTA = {
  TMUVD: '/goal/kota-neet-coaching/TMUVD/centre/Kota-Centre/NXG6I0UBPB', // pragma: allowlist secret
  YOTUH: '/goal/kota-neet-coaching/YOTUH/centre/Kota-Centre/NXG6I0UBPB' // pragma: allowlist secret
};

// tiles content for sbscription page when only one subscription is avaialble
export const plusSubscriptionTiles = [
  {
    subLabel: 'Learn with the best educators for online $goal_name preparation',
    label: "India's top educators"
  },
  {
    subLabel:
      'Follow all your classes, practice & mock tests on a single unified planner',
    label: 'Fully organized planner'
  },
  {
    subLabel:
      'Live classes, practice questions, mock tests, doubt solving and much more',
    label: 'Best-in-class learning experience'
  },
  {
    subLabel:
      '10000+ questions in the question-bank with detailed soultions, report and insights',
    label: 'Tests and unlimited practice'
  }
];
